<template>
  <NoDataTable v-if="!dataDetails.companyname" />
  <div v-else-if="dataDetails.companyname && dataDetails.status !== 201">
    <div class="header-flex">
      <div class="header-title">
        <h3>{{ dataDetails.companyname }}</h3>
        <h4>
          {{ dataDetails.report.value }}
        </h4>
        <h4>
          {{
            convertDateReportFormat(dataDetails.dateFrom, dataDetails.dateTo)
          }}
        </h4>
      </div>
      <input type="button" value="Download Excel" @click="exportTableToExcel" />
    </div>

    <HeroTablePage @selectedHandler="getDataSelected" />
    <div class="main-table">
      <table id="excelDownload">
        <thead>
          <tr>
            <th class="col-span-max">Company</th>
            <th class="col-span-1">Approval No.</th>
            <th class="col-span-5">Member Name</th>
            <th class="col-span-3">Admit Date</th>
            <th class="col-span-3">Discharge Date</th>
            <th class="col-span-max">Provider Name</th>
            <th class="col-span-2">Availment Type</th>
            <th class="col-span-3">Out-Patient Type</th>
            <th class="col-span-3">Pre-Existing Cov.</th>
            <th class="col-span-2">Guaranteed Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in modifiedDataHandler" :key="index">
            <td class="freeze">{{ item['Classification'] }}</td>
            <td>{{ item['ApprovalNo'] }}</td>
            <td>{{ item['MemberName'] }}</td>
            <td>{{ convertDateFormat(item['AdmitDate']) }}</td>
            <td>{{ convertDateFormat(item['DischargeDate']) }}</td>
            <td>{{ item['ProviderName'] }}</td>
            <td>{{ item['AvailType'] }}</td>
            <td>{{ item['OPType'] }}</td>
            <td>{{ item['Pre-Existing Cov.'] }}</td>
            <td class="amount-alignment">
              {{ convertAmountFormat(item['Cov. Amount']) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <PaginationGrid
      :totalPages="totalPages"
      :currentPage="paginationItem.currentPage"
      @update:currentPage="handlePageChange"
    />
  </div>
  <div v-else>
    <div class="header-title">
      <h3>{{ dataDetails.companyname }}</h3>
      <h4>
        {{ dataDetails.report.value }}
      </h4>
      <h4>
        {{ convertDateReportFormat(dataDetails.dateFrom, dataDetails.dateTo) }}
      </h4>
    </div>
    <NotFoundDataTable />
  </div>
</template>
<script>
import PaginationGrid from '@/components/common/HeroPagination.vue';
import HeroTablePage from '@/components/common/HeroTablePage.vue';
import UsedFormatUtils from '@/utils/format';
import UsedPaginationUtils from '@/utils/pagination';
import { computed, watch, inject } from 'vue';
import ExcelJS from 'exceljs';
export default {
  components: { PaginationGrid, HeroTablePage },
  props: {
    dataResult: Object,
    dataDetails: Object,
    searchData: String,
  },
  setup(props) {
    const { convertDateReportFormat, convertDateFormat, convertAmountFormat } =
      UsedFormatUtils();

    const { paginationItem, filterLimit } = UsedPaginationUtils();
    const moment = inject('$moment');
    const modifiedDataHandler = computed(() => {
      const dataItems = props.dataResult || [];
      const search = (props.searchData || '').toLowerCase().trim();
      const pageSize = paginationItem.PageSize || 10;
      const currentPage = paginationItem.currentPage || 1;

      const filteredData = dataItems.filter((item) => {
        return item.MemberName?.toLowerCase().includes(search);
      });

      const startIdx = (currentPage - 1) * pageSize;
      const endIdx = currentPage * pageSize;
      const paginatedData = filteredData.slice(startIdx, endIdx);
      return paginatedData;
    });

    const totalPages = computed(() =>
      Math.ceil(props.dataResult.length / paginationItem.PageSize)
    );

    watch(() => props.searchData, modifiedDataHandler);
    const handlePageChange = (page) => {
      paginationItem.currentPage = page;
      watch(() => paginationItem.currentPage, modifiedDataHandler);
    };
    const getDataSelected = (data) => {
      paginationItem.PageSize = data;
      watch(() => paginationItem.PageSize, modifiedDataHandler);
    };
    const exportTableToExcel = async () => {
      try {
        if (!props.dataResult || props.dataResult.length === 0) {
          console.error('No data available!');
          return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet1');

        // Add Title and Headers
        worksheet.getCell('A1').value = 'Company Availment Report';
        worksheet.getCell('A1').font = { bold: true, size: 13 };

        worksheet.getCell('A2').value = props.dataDetails.companyname;
        worksheet.getCell('A2').font = { bold: true, size: 12 };

        worksheet.getCell('A3').value = props.dataDetails.report.value;
        worksheet.getCell('A3').font = { bold: true, size: 12 };

        worksheet.getCell(
          'A4'
        ).value = `Coverage Range: ${convertDateReportFormat(
          props.dataDetails.dateFrom,
          props.dataDetails.dateTo
        )}`;
        worksheet.getCell('A4').font = { size: 12 };

        worksheet.getCell('A5').value = `Extracted Date: ${moment().format(
          'MMMM D, YYYY | h:mmA'
        )}`;
        worksheet.getCell('A5').font = { size: 12 };

        worksheet.addRow([]); // Empty row for spacing
        worksheet.addRow([]); // Empty row for spacing
        worksheet.addRow([]); // Empty row for spacing
        // Extract headers dynamically from keys

        const headers = Object.keys(props.dataResult[0]);

        // Modify the header for 'companyname' column to 'Company Name'
        const modifiedHeaders = headers.map((header) => {
          if (header === 'Classification') {
            return 'Company Name'; // Change the title for 'companyname' column
          }
          if (header === 'ApprovalNo') {
            return 'Approval No.'; // Change the title for 'companyname' column
          }
          if (header === 'MemberName') {
            return 'Member Name'; // Change the title for 'companyname' column
          }
          if (header === 'AdmitDate') {
            return 'Admit Date'; // Change the title for 'companyname' column
          }
          if (header === 'DischargeDate') {
            return 'Discharge Date'; // Change the title for 'companyname' column
          }
          if (header === 'ProviderName') {
            return 'Provider Name'; // Change the title for 'companyname' column
          }
          if (header === 'AvailType') {
            return 'Availment Type'; // Change the title for 'companyname' column
          }
          if (header === 'OPType') {
            return 'Out-Patient Type'; // Change the title for 'companyname' column
          }
          if (header === 'Pre-Existing Cov.') {
            return 'Pre-Existing Cov.'; // Change the title for 'companyname' column
          }
          if (header === 'Cov. Amount') {
            return 'Guaranteed Amount'; // Change the title for 'companyname' column
          }
          return header; // Leave other headers unchanged
        });

        const headerRow = worksheet.addRow(modifiedHeaders);
        headerRow.font = { bold: true };

        // Apply border to header row
        headerRow.eachCell((cell) => {
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          };
        });
        // Manually set column widths for specific columns
        [1, 6].forEach((index) => (worksheet.getColumn(index).width = 50));
        [3].forEach((index) => (worksheet.getColumn(index).width = 40));
        worksheet.getColumn(9).numFmt = '"₱"#,##0.00';
        [4, 5].forEach(
          (index) =>
            (worksheet.getColumn(index).alignment = { horizontal: 'left' })
        );
        // Dynamically set width for other columns based on header length
        headers.forEach((header, index) => {
          if (![0, 2, 5].includes(index)) {
            // Exclude columns A, C, and F
            const column = worksheet.getColumn(index + 1); // 1-based index
            column.width = header.length < 20 ? 20 : header.length + 5; // Dynamic width
          }
        });

        // Identify index of date columns (D = index 3, E = index 4, 0-based)
        const dateColumns = [3, 4];

        // Extract row data and apply formatting
        props.dataResult.forEach((row) => {
          const rowData = worksheet.addRow(headers.map((key) => row[key]));

          rowData.eachCell((cell, colNumber) => {
            // Apply border
            cell.border = {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' },
            };

            // Apply date format if the column is D or E
            if (dateColumns.includes(colNumber - 1)) {
              cell.numFmt = 'yyyy-mm-dd'; // Change format as needed
              cell.value = row[headers[colNumber - 1]]
                ? new Date(row[headers[colNumber - 1]])
                : null;
            }
          });
        });

        // Download the Excel file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'table-data.xlsx';
        link.click();
      } catch (error) {
        console.error('Error exporting table to Excel:', error);
      }
    };

    return {
      convertDateReportFormat,
      convertDateFormat,
      convertAmountFormat,
      modifiedDataHandler,
      paginationItem,
      totalPages,
      handlePageChange,
      getDataSelected,
      filterLimit,
      exportTableToExcel,
    };
  },
};
</script>
<style scoped>
.header-title {
  margin-top: 18px;
}
.header-title h3 {
  color: #f37420;
}
.header-title h4 {
  color: #4e4e4e;
  font-weight: 700;
}
.main-table {
  max-width: 1550px;
  overflow: auto;
}
.col-span-1 {
  min-width: 140px;
}
.col-span-2 {
  min-width: 180px;
}
.col-span-3 {
  min-width: 200px;
}
.col-span-4 {
  min-width: 250px;
}
.col-span-5 {
  min-width: 300px;
}
.col-span-max {
  min-width: 540px;
}
td {
  text-align: left;
}

.amount-alignment {
  text-align: right;
}
</style>
